





















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class CookieWarning extends Vue {

  get showPolicy() {
    return localStorage.getItem('cookie-policy-visibility') !== 'hidden'
  }

  close() {
    localStorage.setItem('cookie-policy-visibility', 'hidden')
  }

}
